import { CourseName } from './CourseName';
import { CourseCard } from './CourseCard';
import { CoursePrice } from './CoursePrice';
import { CourseRating } from './CourseRating';
import { CourseDuration } from './CourseDuration';
import { CourseInWishlist } from './CourseInWishlist';
import { areaDescription } from './areaDesc';

export const course = {
  CourseCard,
  CourseName,
  CoursePrice,
  CourseRating,
  CourseDuration,
  CourseInWishlist,
  areaDescription
};
